const slider = new Swiper(".slider", {
  //navigation: {
  //  nextEl: ".swiper-button-next",
  //  prevEl: ".swiper-button-prev",
  //},
  autoplay: false,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  }
});

// thumbnailを追従させたくないので、slideToメソッドでサムネイルと連動
function thumbnail(index) {
  slider.slideTo(index);
}